import { render, staticRenderFns } from "./PrescriptionInfo.vue?vue&type=template&id=450e0854&scoped=true"
import script from "./PrescriptionInfo.vue?vue&type=script&lang=js"
export * from "./PrescriptionInfo.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionInfo.vue?vue&type=style&index=0&id=450e0854&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450e0854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('450e0854')) {
      api.createRecord('450e0854', component.options)
    } else {
      api.reload('450e0854', component.options)
    }
    module.hot.accept("./PrescriptionInfo.vue?vue&type=template&id=450e0854&scoped=true", function () {
      api.rerender('450e0854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/settlement/takeChmedicine/PrescriptionInfo.vue"
export default component.exports